import { getTransformationImageObj } from 'petdna-lib-uicomponents/helpers';
import {
  buttonFragment,
  colorsFragment,
  getImageQueryFragment,
  getImageWithAltFragment,
  kitPriceFragment,
} from 'petdna-lib-uicomponents/hygraph';

const popupPetSettingFragment = `
  ... on PopupPetSetting {
    __typename
    id
    name
    showDate
    petAgeFrom
    petAgeTo
    entitlements
    healthUpgrade
    birthdayRelated
    breeds {
      breedID
    }
    noLocation
    saveToStorage
  }
`;

const popupUserSettingFragment = `
  ... on PopupUserSetting {
    __typename
    id
    name
    showDate
    noSurveyFilled
    noDisplayedUsername
    saveToStorage
  }
`;

const popupSimpleContentFragment = `
  ... on PopupSimpleContent {
    __typename
    title
    titleColor {
      ${colorsFragment}
    }
    icon {
      ${getImageQueryFragment(getTransformationImageObj(275, 440))}
    }
    imageWithAlt {
      ${getImageWithAltFragment(getTransformationImageObj(275, 440))}
    }
    text
    textColor {
      ${colorsFragment}
    }
    learnMoreLabel
    learnMoreLabelColor {
      ${colorsFragment}
    }
    learnMoreLink
    inputField
    inputLabel
    inputPlaceholder
    button {
      ${buttonFragment}
    }
    buttonAction
    kitPrice {
      ${kitPriceFragment}
    }
    closeButton
    closeButtonText
  }
`;

export const popupFragment = `
  ... on Popup {
    id
    name
    topBorderColor {
      ${colorsFragment}
    }
    content {
      ${popupSimpleContentFragment}
    }
    active
    setting {
      ${popupPetSettingFragment}
      ${popupUserSettingFragment}
    }
  }
`;

export const POPUPS_QUERY = `
  query popups(
    $where: PopupWhereInput = {}
  ) {
    popups(
      first: 100
      where: $where
    ) {
      ${popupFragment}
    }
  }
`;
